import React from "react";
import { View, XStack } from "tamagui";
import { HeaderButton } from "../../../../components/design-system/Button/HeaderButton";
import { ArrowLeftIcon } from "../../../../components/design-system/icons";
import { Pencil, Share as TMShare } from "@tamagui/lucide-icons";

type EventDetailHeaderProps = {
  onClose: () => void;
  onEdit: () => void;
  onShare: () => void;
  isCurrentUserHost: boolean;
  canShare: boolean;
};

export const EventDetailHeader = ({
  onClose,
  onEdit,
  onShare,
  isCurrentUserHost,
  canShare,
}: EventDetailHeaderProps) => {
  return (
    <View
      zIndex={100}
      w="100%"
      px="$4"
      pb="$4"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <HeaderButton onPress={onClose}>
        <ArrowLeftIcon width={16} height={16} color="black" />
      </HeaderButton>
      <XStack gap="$2">
        {isCurrentUserHost ? (
          <HeaderButton onPress={onEdit}>
            <Pencil width={20} height={20} />
          </HeaderButton>
        ) : null}
        {canShare ? (
          <HeaderButton onPress={onShare}>
            <TMShare width={20} height={20} />
          </HeaderButton>
        ) : null}
      </XStack>
    </View>
  );
};
